import { EmploymentTerminationKind, EmploymentTerminationUsecase, UserDefinedRow } from "../../model";
import { IncomeTypeMetadata, IncomeTypesLogic } from "../../logic";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";

/** Client-side logic for EmploymentTerminationUsecase  */
export class EmploymentTerminationUsecaseLogic extends BaseUsecaseLogic {
  /** Gets validation message for IrIncomeTypeUsecase  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage | undefined {
    const data: EmploymentTerminationUsecase = row.data || {};
    const codeData = this.getCodeData(data.kind);
    if (!codeData) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType",
      };
    }
    return undefined;
  }

  private getCodeData(kind: EmploymentTerminationKind | null | undefined): IncomeTypeMetadata | undefined {
    if (kind) {
      let code = 0;
      switch (kind) {
        case EmploymentTerminationKind.NoticePeriodCompensation:
          code = 208;
          break;
        case EmploymentTerminationKind.MonetaryWorkingTimeBankCompensation:
          code = 224;
          break;
        case EmploymentTerminationKind.TerminationAndLayOffDamages:
          code = 229;
          break;
        case EmploymentTerminationKind.VoluntaryTerminationCompensation:
          code = 231;
          break;
        case EmploymentTerminationKind.PensionPaidByEmployer:
          code = 338;
          break;
        case EmploymentTerminationKind.Undefined:
        default:
          code = 0;
          break;
      }
      return IncomeTypesLogic.getAll().find((x) => x.code === code);
    }
    return undefined;
  }

  private isIrIncomeTypeLabel(label: string): boolean {
    return IncomeTypesLogic.getAll().some((x) => x.label === label);
  }
}
